// extracted by mini-css-extract-plugin
module.exports = {"body":"VoronView_body__3ARgN","images":"VoronView_images__XIZQ8","video":"VoronView_video__217Rn","panel":"VoronView_panel__1jado"};